/*
  CB Step Picker — comportamiento del selector visual de variantes.
  El markup, los datos y los estilos los pone snippets/cb-step-picker.liquid.
  Vive acá afuera para que se cachee y para poder tocarlo sin resubir todo.

  19 ago 2026 — varias opciones por producto. Cada bloque maneja UNA opción y
  todos leen la misma tabla de variantes: el precio de cada fila se resuelve
  contra lo elegido en las OTRAS opciones. Sin eso el Kit Asilo con la
  borraccia MATEO seguía diciendo "€49" en las tovagliette.
*/
(function () {
  if (window._cbspInit) return;
  window._cbspInit = true;

  // Todos los bloques del mismo producto tienen que repintarse juntos: tocar
  // una opción cambia los precios de las otras.
  var GROUPS = {};

  // Ficha con foto recién tocada: la galería tiene que terminar mostrando ESA
  // foto (las hojas del diario), no la de la variante, que es la tapa del
  // formato. Dawn pone la de la variante cuando termina de cargar, así que se
  // reintenta un rato. Cualquier otro clic en el selector lo cancela.
  var WANT = null;
  function applyWant(sid) {
    if (!WANT || Date.now() > WANT.until) { WANT = null; return; }
    var g = document.querySelector('#MainProduct-' + sid + ' media-gallery') ||
            document.querySelector('media-gallery');
    if (!g || !g.setActiveMedia) return;
    var items = g.querySelectorAll('li[data-media-id]');
    for (var i = 0; i < items.length; i++) {
      var im = items[i].querySelector('img');
      if (!im || (im.getAttribute('src') || '').indexOf(WANT.base) < 0) continue;
      var first = items[i].parentElement.firstElementChild === items[i];
      if (!first || !items[i].classList.contains('is-active')) {
        g.setActiveMedia(items[i].dataset.mediaId, true);
      }
      return;
    }
  }
  function wantPic(pic, sid) {
    WANT = { base: pic.split('?')[0].split('/').pop(), until: Date.now() + 4000 };
    [500, 1100, 1900, 3000].forEach(function (ms) {
      setTimeout(function () { applyWant(sid); }, ms);
    });
  }

  function initOne(host) {
      var SID = host.dataset.sid || host.id.replace(/^cbsp-/, '');
      var jsonEl = document.getElementById(host.dataset.jsonId || ('cbsp-json-' + SID));
      if (!jsonEl) return;

      var cfg;
      try { cfg = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var IDX = parseInt(host.dataset.optionIndex, 10) || 0;

      // Tabla de variantes del producto (una sola para todos los bloques).
      var VARS = [];
      var varsEl = document.getElementById(cfg.varsId || ('cbsp-vars-' + SID));
      if (varsEl) {
        try { VARS = (JSON.parse(varsEl.textContent) || {}).variants || []; } catch (e) { VARS = []; }
      }
      if (!VARS.length) return;
      var OPT_COUNT = (VARS[0].o || []).length;

      // ⚠️ Dawn REEMPLAZA el <variant-selects> entero en cada cambio de variante
      // (product-info.js → updateOptionValues), así que una referencia fija al
      // control queda huérfana al primer clic: se resuelve de cero cada vez.
      // ⚠️ Y el control puede ser <select> O radios (pills) según el editor de
      // temas. Hay que soportar los dos — este tema usa pills.
      function selects() {
        return document.querySelector('#MainProduct-' + SID + ' variant-selects')
            || document.querySelector('variant-selects');
      }
      function controlAt(i) {
        var vs = selects();
        if (!vs) return null;
        // El N-ésimo .product-form__input corresponde a la N-ésima opción.
        var wrap = vs.querySelectorAll('.product-form__input')[i];
        if (!wrap) return null;
        var sel = wrap.querySelector('select');
        if (sel) return { type: 'select', wrap: wrap, el: sel };
        var radios = wrap.querySelectorAll('input[type="radio"]');
        if (radios.length) return { type: 'radio', wrap: wrap, els: radios };
        return null;
      }
      function getControl() { return controlAt(IDX); }

      function valueOf(c) {
        if (!c) return null;
        if (c.type === 'select') return c.el.value;
        for (var i = 0; i < c.els.length; i++) if (c.els[i].checked) return c.els[i].value;
        return null;
      }
      function currentValue() { return valueOf(getControl()); }

      // Lo elegido en TODAS las opciones. Es lo que hace que los precios de una
      // fila correspondan a la combinación que la clienta está mirando.
      function selection() {
        var out = [];
        for (var i = 0; i < OPT_COUNT; i++) {
          var v = valueOf(controlAt(i));
          out.push(v == null ? '' : String(v).trim());
        }
        return out;
      }

      // Sin un control que podamos manejar, el snippet se queda invisible y la
      // ficha funciona como siempre: nunca un título huérfano sin opciones.
      if (!getControl()) return;

      // El snippet se renderiza al principio de la sección (único punto de
      // enganche), así que se muda solo debajo del selector de variantes. Con
      // varios bloques, cada uno se cuelga detrás del anterior.
      var vsel = selects();
      if (!vsel || !vsel.parentNode) return;
      var anchor = vsel;
      while (anchor.nextSibling && anchor.nextSibling.nodeType === 1 &&
             anchor.nextSibling.hasAttribute('data-cbsp') && anchor.nextSibling !== host) {
        anchor = anchor.nextSibling;
      }
      anchor.parentNode.insertBefore(host, anchor.nextSibling);
      host.hidden = false;

      // Esconder el control original. Sigue en el DOM y sigue siendo la fuente
      // de verdad para Dawn — sólo deja de verse. Hay que re-aplicarlo después
      // de cada reemplazo, por lo mismo de arriba.
      function hideNative() {
        var c = getControl();
        if (c && c.wrap) c.wrap.style.display = 'none';
      }
      hideNative();

      var SEP = cfg.sep;

      // La variante de un valor de ESTA opción, respetando lo elegido en las
      // demás. Si la combinación no existe, cae a la primera con ese valor.
      function variantFor(value, sel) {
        var loose = null;
        for (var i = 0; i < VARS.length; i++) {
          var o = VARS[i].o || [];
          if ((o[IDX] || '') !== value) continue;
          var match = true;
          for (var j = 0; j < OPT_COUNT; j++) {
            if (j === IDX) continue;
            if (sel[j] && o[j] !== sel[j]) { match = false; break; }
          }
          if (match) return VARS[i];
          if (!loose || (!loose.a && VARS[i].a)) loose = VARS[i];
        }
        return loose;
      }

      // Los valores de esta opción, resueltos contra la selección actual.
      function build() {
        var sel = selection();
        return cfg.values.map(function (value) {
          var parts = value.split(SEP);
          var v = variantFor(value, sel) || {};
          return {
            value: value,
            prefix: (parts[0] || '').trim(),
            suffix: (parts.slice(1).join(SEP) || '').trim(),
            price: v.p || 0,
            priceFormatted: v.pf || '',
            image: v.img || '',
            qty: (typeof v.q === 'number') ? v.q : -1,
            available: !!v.a
          };
        });
      }

      var items = build();

      // El precio de venta viene ya formateado desde Liquid, con el mismo filtro
      // del tema. money() es sólo el respaldo por si faltara.
      var NO_DEC = /no_decimals/.test(cfg.moneyFormat || '');
      function money(cents) {
        if (NO_DEC) return '€' + Math.round(cents / 100);
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }

      // Los importes CALCULADOS (por unidad, ahorro, sobreprecio) NUNCA se
      // redondean: 13,45 y 12,63 se convertirían los dos en "€13" y se pierde
      // justo lo que queremos mostrar. Los enteros sí salen enteros ("+€10").
      function moneyEach(cents) {
        var n = cents / 100;
        if (Math.round(n * 100) % 100 === 0) return '€' + Math.round(n);
        return '€' + n.toFixed(2).replace('.', ',');
      }
      function slug(s) {
        return s.toLowerCase().trim()
          .replace(/[àáâä]/g, 'a').replace(/[èéêë]/g, 'e').replace(/[ìíîï]/g, 'i')
          .replace(/[òóôö]/g, 'o').replace(/[ùúûü]/g, 'u')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }

      // Le dice a Dawn que cambió la variante. Cambiamos el control real y
      // disparamos change: así precio, galería, stock y botón de comprar se
      // actualizan solos con el código del tema.
      function commit(value) {
        WANT = null;
        var c = getControl();
        if (!c) return;
        if (c.type === 'select') {
          if (c.el.value === value) return;
          c.el.value = value;
          c.el.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        for (var i = 0; i < c.els.length; i++) {
          if (c.els[i].value === value) {
            if (c.els[i].checked) return;
            c.els[i].checked = true;
            c.els[i].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }

      // Si la variante tiene foto propia, gana ella: es lo que mostraba el
      // swatch nativo del tema y se ve mucho mejor que un cuadradito dibujado.
      function chipFor(suffix, img) {
        if (img) {
          return '<span class="cbsp__chip cbsp__chip--photo">'
               + '<img src="' + img + '" alt="" loading="lazy">' + '</span>';
        }
        var s = slug(suffix);
        var inner = '';
        if (s === 'spirale') {
          inner = '<span class="cbsp__bind"><i class="cbsp__coil"></i><i class="cbsp__coil"></i>'
                + '<i class="cbsp__coil"></i><i class="cbsp__coil"></i></span>';
        } else if (s === 'a-dischi') {
          inner = '<span class="cbsp__bind"><i class="cbsp__disc"></i><i class="cbsp__disc"></i>'
                + '<i class="cbsp__disc"></i></span>';
        }
        return '<span class="cbsp__chip cbsp__chip--' + s + '">' + inner + '</span>';
      }

      // Texto de ayuda: sólo para valores conocidos. Uno nuevo sale sin
      // subtítulo, nunca con algo inventado.
      var HINTS = {
        'a5-rigida':      'Sta nella borsa. Copertina di cartone.',
        'a4-flessibile':  'Più spazio per scrivere.',
        'olografica':     'Cambia colore con la luce.',
        'opaca':          'Sobria, non fa riflessi.',
        'spirale':        'Si apre piatta sul banco.',
        'a-dischi':       'Sposti e aggiungi i fogli.'
      };
      function hint(s) { return HINTS[slug(s)] || ''; }

      // ¿Los valores de esta opción cuestan distinto? Si todos valen igual
      // (los colores), repetir el precio en cada fila es ruido.
      function varies() {
        for (var i = 1; i < items.length; i++) if (items[i].price !== items[0].price) return true;
        return false;
      }
      // El sobreprecio del upgrade, SIEMPRE contra el valor más barato de la
      // opción. Contra el elegido, la fila barata mostraba "-€10" en rojo y se
      // leía como un recargo; y el número saltaba en cada clic.
      function deltaFrom(it) {
        var base = items[0].price;
        for (var i = 1; i < items.length; i++) if (items[i].price < base) base = items[i].price;
        var d = it.price - base;
        if (d <= 0) return '';
        return '<span class="cbsp__delta">+' + moneyEach(d) + '</span>';
      }
      // Sólo cuenta como "cantidad" si el valor ARRANCA con un número
      // ("2 fratelli"). En "Design + Nome" no hay cantidad que mostrar.
      // Sin expresión regular a propósito: al subir por API las barras
      // invertidas se duplican y el patrón deja de matchear, sin avisar.
      function qtyOf(it) {
        var n = parseInt(it.prefix, 10);
        return (isNaN(n) || n < 1) ? 0 : n;
      }
      // Hace falta más de un escalón numerado para que sea una escalera. Con uno
      // solo ("1 tovaglietta" contra "Pack da 3") lo que la clienta decide es un
      // upgrade, y ahí manda el salto de precio.
      function isLadderOfQty() {
        var c = 0;
        for (var i = 0; i < items.length; i++) if (qtyOf(items[i]) > 0) c++;
        return c > 1;
      }
      // "Ultimo pezzo" sólo cuando de verdad queda uno y se puede comprar.
      // Si TODOS los valores están en 1 (IRIS: un set por color), repetir el
      // cartel en cada fila lo convierte en decoración: ahí se dice una vez
      // arriba, al lado del nombre de la opción.
      function allLast() {
        var av = items.filter(function (i) { return i.available; });
        return av.length > 1 && av.every(function (i) { return i.qty === 1; });
      }
      function lastOne(it) {
        if (!it.available || it.qty !== 1 || allLast()) return '';
        return '<span class="cbsp__last">Ultimo pezzo</span>';
      }

      // Fotos propias de la opción (metafield custom.foto_opzioni → {"Diario":
      // {"Mensile": url, ...}}). null = la opción se dibuja como siempre.
      var PICS = (cfg.pics && typeof cfg.pics === 'object') ? cfg.pics : null;
      function sized(url, w) {
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
      }

      var state = { value: cfg.selected };
      var repaint = function () {};

      /* ─────────────── MODO PASOS ─────────────── */
      if (host.dataset.mode === 'steps') {
        var step2 = host.querySelector('[data-cbsp-step2]');
        var label2 = host.querySelector('[data-cbsp-label2]');
        var chosen1 = host.querySelector('[data-cbsp-chosen1]');
        var chosen2 = host.querySelector('[data-cbsp-chosen2]');

        host.querySelectorAll('[data-cbsp-hint]').forEach(function (el) {
          el.textContent = hint(el.dataset.cbspHint);
        });

        function currentPrefix() {
          var it = items.filter(function (i) { return i.value === state.value; })[0];
          return it ? it.prefix : items[0].prefix;
        }

        function renderStep2() {
          var pfx = currentPrefix();
          var subset = items.filter(function (i) { return i.prefix === pfx; });

          // El nombre del paso 2 depende del paso 1: en A5 cambia el acabado de
          // la tapa, en A4 cambia la encuadernación. Son dos cosas distintas.
          label2.textContent = subset.some(function (i) { return slug(i.suffix) === 'a-dischi'; })
            ? 'Come la rilegiamo?'
            : 'Come la vuoi?';

          step2.innerHTML = '';
          subset.forEach(function (it) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cbsp__opt';
            b.setAttribute('aria-pressed', String(it.value === state.value));
            if (!it.available) b.setAttribute('data-cbsp-soldout', 'true');
            b.innerHTML =
              chipFor(it.suffix, host.dataset.swatch ? '' : it.image) +
              '<span class="cbsp__txt"><span class="cbsp__t">' + it.suffix + '</span>' +
              '<span class="cbsp__d">' + hint(it.suffix) + '</span>' + lastOne(it) + '</span>' +
              '<span class="cbsp__price">' + (it.priceFormatted || money(it.price)) + '</span>';
            b.addEventListener('click', function () {
              state.value = it.value;
              commit(it.value);
              paintAll();
            });
            step2.appendChild(b);
          });
        }

        function paint() {
          var pfx = currentPrefix();
          host.querySelectorAll('[data-cbsp-prefix]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b.dataset.cbspPrefix === pfx));
          });
          chosen1.textContent = '· ' + pfx;
          var it = items.filter(function (i) { return i.value === state.value; })[0];
          chosen2.textContent = it ? '· ' + it.suffix : '';
          renderStep2();
          host.dispatchEvent(new CustomEvent('cbsp:change', {
            bubbles: true, detail: { value: state.value, prefix: pfx, suffix: it ? it.suffix : '' }
          }));
        }

        host.querySelectorAll('[data-cbsp-prefix]').forEach(function (b) {
          b.addEventListener('click', function () {
            var pfx = b.dataset.cbspPrefix;
            // Al cambiar de formato saltamos al primer valor disponible de ese
            // formato — nunca a una combinación que no existe.
            var first = items.filter(function (i) { return i.prefix === pfx && i.available; })[0]
                     || items.filter(function (i) { return i.prefix === pfx; })[0];
            if (!first) return;
            state.value = first.value;
            commit(first.value);
            paintAll();
          });
        });

        repaint = paint;

      /* ─────────────── ESCALERA / FOTO ─────────────── */
      } else {
        var wrap = host.querySelector('[data-cbsp-ladder]');
        var chosen = host.querySelector('[data-cbsp-chosen1]');

        function paintLadder() {
          // Precio de referencia = el del escalón de 1. Sirve para calcular
          // cuánto se ahorra DE VERDAD contra comprarlos de a uno.
          var unitBase = 0;
          items.forEach(function (it) { if (qtyOf(it) === 1) unitBase = it.price; });
          var showPrice = varies();
          var qtyLadder = isLadderOfQty();

          // 27 ago 2026 — MODO GRILLA: muchas telas/colores (>= 6), todas con
          // foto y al mismo precio (el soffietto de NINA: 12 filas de 90 px
          // eran una pantalla entera antes de llegar al precio). Se dibujan
          // como mosaico de muestras con el nombre debajo. Decidido por los
          // datos, como los otros modos: no hay configuración.
          var tiles = !showPrice && !qtyLadder && items.length >= 6 &&
                      items.every(function (i) { return !!i.image; });
          wrap.classList.toggle('cbsp__opts--grid', tiles);

          // 30 set 2026 — circulitos de color uno al lado del otro (tag
          // swatch-colore, Album Bebè). La foto de la variante ES el color.
          var dots = host.dataset.swatch === 'dot';
          wrap.classList.toggle('cbsp__opts--dots', dots);

          // 2 oct 2026 — FICHAS CON FOTO PROPIA (Diario de la Sostegno): la
          // opción trae sus fotos en el metafield custom.foto_opzioni, aparte de
          // la foto de la variante (esa sigue mandando en la galería). Sirve
          // para mostrar CÓMO ES por dentro lo que se elige.
          var cards = !!PICS && !dots;
          wrap.classList.toggle('cbsp__opts--cards', cards);

          wrap.innerHTML = '';
          items.forEach(function (it) {
            var n = qtyOf(it);

            if (cards) {
              var pic = PICS[it.value] || '';
              var c = document.createElement('button');
              c.type = 'button';
              c.className = 'cbsp__opt cbsp__opt--card';
              c.setAttribute('aria-pressed', String(it.value === state.value));
              if (!it.available) c.setAttribute('data-cbsp-soldout', 'true');
              var cprice = showPrice ? ((it.priceFormatted || money(it.price)) + deltaFrom(it)) : '';
              c.innerHTML =
                (pic ? '<span class="cbsp__pic"><img src="' + sized(pic, 480) + '" alt="' +
                       it.prefix + '" loading="lazy">' +
                       '<span class="cbsp__zoom" aria-label="Ingrandisci" title="Ingrandisci">' +
                       '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
                       '<circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2.2"/>' +
                       '<path d="M15.5 15.5L21 21" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>' +
                       '</svg></span></span>' : '') +
                '<span class="cbsp__t">' + it.prefix + '</span>' +
                '<span class="cbsp__price">' + cprice + '</span>' + lastOne(it);
              c.addEventListener('click', function (e) {
                if (pic && e.target.closest && e.target.closest('.cbsp__zoom')) {
                  openZoom(sized(pic, 1800), it.prefix);
                  return;
                }
                state.value = it.value;
                commit(it.value);
                if (pic) wantPic(pic, SID);
                paintAll();
              });
              wrap.appendChild(c);
              return;
            }

            if (dots) {
              var d = document.createElement('button');
              d.type = 'button';
              d.className = 'cbsp__dot';
              d.setAttribute('aria-pressed', String(it.value === state.value));
              d.setAttribute('aria-label', it.prefix);
              d.innerHTML = '<i style="background-image:url(\'' + it.image + '\')"></i>' +
                            '<span>' + it.prefix + '</span>';
              d.addEventListener('click', function () {
                state.value = it.value;
                commit(it.value);
                paintAll();
              });
              wrap.appendChild(d);
              return;
            }

            if (host.dataset.swatch === 'noimg') it.image = '';

            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cbsp__opt';
            b.setAttribute('aria-pressed', String(it.value === state.value));
            if (!it.available) b.setAttribute('data-cbsp-soldout', 'true');

            if (tiles) {
              b.className += ' cbsp__opt--tile';
              b.innerHTML =
                '<span class="cbsp__chip cbsp__chip--photo cbsp__chip--tile">' +
                '<img src="' + it.image + '" alt="" loading="lazy"></span>' +
                '<span class="cbsp__txt"><span class="cbsp__t">' + it.prefix + '</span>' +
                lastOne(it) + '</span>';
              b.addEventListener('click', function () {
                state.value = it.value;
                commit(it.value);
                paintAll();
              });
              wrap.appendChild(b);
              return;
            }

            // El precio por unidad baja con cada hermano y la clienta hoy saca
            // la cuenta sola: se le muestra hecha, con el ahorro real.
            var each = '';
            if (qtyLadder && n > 1) {
              // "a bambino" cuando el valor habla de chicos; si no, neutro.
              var who = /fratell|bambin/i.test(it.prefix) ? ' a bambino' : " l'uno";
              each = '<span class="cbsp__each">' + moneyEach(it.price / n) + who;
              var saving = (unitBase * n) - it.price;
              if (unitBase > 0 && saving > 0) {
                each += ' · <b>risparmi ' + moneyEach(saving) + '</b>';
              }
              each += '</span>';
            }
            // Fuera de las escaleras de cantidad, lo que importa es el salto:
            // "+€10" dice más que "€59".
            if (!qtyLadder) each = deltaFrom(it);

            // Prioridad del lado izquierdo: foto de la variante → número → nada.
            var lead = it.image ? chipFor('', it.image)
                     : (qtyLadder && n > 0 ? '<span class="cbsp__count">' + n + '</span>' : '');

            var price = showPrice ? ((it.priceFormatted || money(it.price)) + each) : '';

            b.innerHTML =
              lead +
              '<span class="cbsp__txt"><span class="cbsp__t">' + it.prefix + '</span>' +
              '<span class="cbsp__d">' + it.suffix + '</span>' + lastOne(it) + '</span>' +
              '<span class="cbsp__price">' + price + '</span>';

            b.addEventListener('click', function () {
              state.value = it.value;
              commit(it.value);
              paintAll();
            });
            wrap.appendChild(b);
          });
          var cur = items.filter(function (i) { return i.value === state.value; })[0];
          chosen.textContent = (cur ? '· ' + cur.prefix : '') + (allLast() ? ' · ne resta 1 di ciascuno' : '');
          host.dispatchEvent(new CustomEvent('cbsp:change', {
            bubbles: true, detail: { value: state.value }
          }));
        }

        repaint = paintLadder;
      }

      // Repintar TODOS los bloques del producto: al cambiar una opción cambian
      // los precios y la disponibilidad de las otras.
      function refresh() {
        items = build();
        var v = currentValue();
        if (v) state.value = v;
        repaint();
      }
      function paintAll() {
        var g = GROUPS[SID] || [];
        for (var i = 0; i < g.length; i++) g[i]();
      }
      (GROUPS[SID] = GROUPS[SID] || []).push(refresh);
      refresh();

      // Cuando Dawn reemplaza el <variant-selects> hay que re-esconder el control
      // nuevo y re-sincronizar. El observer cubre también los cambios externos
      // (link con ?variant=, botón atrás).
      var lastSig = selection().join('');
      function resync() {
        hideNative();
        applyWant(SID);
        var sig = selection().join('');
        if (sig === lastSig) return;
        lastSig = sig;
        paintAll();
      }

      var scope = host.closest('product-info') || host.parentElement;
      if (scope && window.MutationObserver) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () { pending = false; resync(); });
        }).observe(scope, { childList: true, subtree: true });
      }

      // Cambios en el control actual que no vinieron de nosotros (teclado,
      // autofill). Se ignoran los de nuestros propios botones, que ya repintan.
      scope && scope.addEventListener('change', function (e) {
        if (!e.target || host.contains(e.target)) return;
        resync();
      });
  }

  // Lupa de las fichas con foto: la página del diario en grande, encima de
  // todo. Se cierra tocando en cualquier lado o con Esc.
  var ZOOM = null;
  function openZoom(src, caption) {
    if (!ZOOM) {
      ZOOM = document.createElement('div');
      ZOOM.className = 'cbsp-zoom';
      ZOOM.setAttribute('role', 'dialog');
      ZOOM.setAttribute('aria-modal', 'true');
      ZOOM.innerHTML = '<figure><img alt=""><figcaption></figcaption></figure>' +
                       '<button type="button" class="cbsp-zoom__x" aria-label="Chiudi">&times;</button>';
      ZOOM.addEventListener('click', closeZoom);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeZoom();
      });
      document.body.appendChild(ZOOM);
    }
    ZOOM.querySelector('img').src = src;
    ZOOM.querySelector('img').alt = caption;
    ZOOM.querySelector('figcaption').textContent = caption;
    ZOOM.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (!ZOOM || !ZOOM.classList.contains('is-open')) return;
    ZOOM.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function boot() {
    var hosts = document.querySelectorAll('[data-cbsp]');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].dataset.cbspReady) continue;
      hosts[i].dataset.cbspReady = '1';
      initOne(hosts[i]);
    }
  }

  // El snippet se renderiza arriba de todo, así que al ejecutarse todavía no
  // existe el <variant-selects> que necesita. Se espera al DOM completo.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
